<template>
  <div class="modal-overlay" @click.self="handleClose">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Order Status</h3>
        <button class="close-btn" @click="handleClose">&times;</button>
      </div>
      <div class="modal-body">
        <div class="warning-message">
          <i class="fas fa-exclamation-triangle warning-icon"></i>
          <p style="margin: 0">{{ partialFailureMessage }}</p>
        </div>

        <div class="failed-orders" v-if="failedOrders.length > 0">
          <h4>Failed Orders:</h4>
          <ul>
            <li v-for="(order, index) in failedOrders" :key="index">
              {{ order }}
            </li>
          </ul>
        </div>
        <div class="payment-message" v-if="paymentRequired && paymentUrl !== ''">
          <p>Would you like to proceed with the payment?</p>
        </div>
      </div>
      <div class="modal-footer">
        <button
          v-if="paymentRequired && paymentUrl !== ''"
          class="btn btn-secondary"
          @click="handleCancel"
        >
          Cancel
        </button>
        <button
          v-if="paymentRequired && paymentUrl !== ''"
          class="btn btn-primary"
          @click="handleProceed"
        >
          Proceed
        </button>
        <button v-else class="btn btn-primary" @click="handleClose">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartialOrderFailureModal",
  props: {
    partialFailureMessage: {
      type: String,
      required: true,
    },
    failedOrders: {
      type: Array,
      default: () => [],
    },
    paymentRequired: {
      type: Boolean,
      default: false,
    },
    paymentUrl: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleProceed() {
      this.$emit("proceed");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  /* border-bottom: 1px solid #e5e7eb; */
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0 8px;
}

.modal-body {
  padding: 16px;
}

.warning-message {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.warning-icon {
  color: #f59e0b;
  margin-right: 8px;
  font-size: 1.25rem;
  margin-top: 2px;
}

.failed-orders {
  margin: 16px 0;
  padding: 12px;
  background-color: #fef2f2;
  border-radius: 4px;
  border-left: 4px solid #ef4444;
}

.failed-orders h4 {
  margin: 0 0 8px 0;
  color: #dc2626;
  font-size: 0.95rem;
}

.failed-orders ul {
  margin: 0;
  padding-left: 20px;
}

.failed-orders li {
  margin-bottom: 4px;
  font-size: 0.9rem;
  color: #6b7280;
}

.payment-message {
  /* margin: 16px 0; */
  padding: 12px;
  /* background-color: #eff6ff; */
  border-radius: 4px;
  /* border-left: 4px solid #3b82f6; */
}

.payment-message p {
  margin: 0;
  color: #1e40af;
  font-weight: 500;
}

.modal-footer {
  display: flex;
  justify-content: center;
  padding: 12px 16px;
  /* border-top: 1px solid #e5e7eb; */
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background-color: #046be1;
  color: white;
  border: 1px solid #046be1;
  border-radius: 13px;
}

.btn-primary:hover {
  background-color: #2563eb;
  border-color: #2563eb;
}

.btn-secondary {
  background-color: white;
  color: #224096;
  border: 1px solid #224096;
  border-radius: 13px;
}

.btn-secondary:hover {
  background-color: #f3f4f6;
}
</style>
